module.exports = __webpack_public_path__ + "files/eac8449ff4deae169cd43c8e6bfccfe7.png";